import { __rest } from "tslib";
import * as React from "react";
import { forwardRef } from "react";
import clsx from 'clsx';
const _AwardIcon = (_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("svg", Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", role: "presentation", width: 16, height: 16, className: clsx("cmp-icon", className), ref: ref }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M4 9a8 8 0 1 1 16 0A8 8 0 0 1 4 9Zm8-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M15.62 14.015a1 1 0 0 1 1.155.815l1.21 7a1 1 0 0 1-1.403 1.078L12 20.798l-4.582 2.11a1 1 0 0 1-1.403-1.079l1.21-6.992a1 1 0 1 1 1.97.341l-.885 5.118 3.272-1.507a1 1 0 0 1 .836 0l3.273 1.507-.886-5.126a1 1 0 0 1 .815-1.155Z", clipRule: "evenodd" }));
};
const AwardIcon = forwardRef(_AwardIcon);
export default AwardIcon;
//# sourceMappingURL=award.js.map